import { Component, Input, OnInit } from '@angular/core';
import { IPmvModel } from '@shared/models/pmv.model';
import { Icon } from '@types-custom/models/ui/icon-model';
import { IPanel } from '@types-custom/models/ui/modal-pmv-model';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'ui-modal-pmv',
  templateUrl: './modal-pmv.component.html',
  styleUrls: ['./modal-pmv.component.scss']
})
export class ModalPmvComponent implements OnInit {
  @Input() properties: IPmvModel | undefined;
  Icon = Icon;

  panels$: BehaviorSubject<IPanel[]> = new BehaviorSubject([]);

  index = 0;

  get panels() {
    return this.panels$.value;
  }

  ngOnInit(): void {

    this.panels$.next([{
      imageOrder: 0 ,
      iamgeBase64: ' '
    }])

    this.properties.dataSource.getPanelsById(this.properties.id)
      .subscribe(panels => this.panels$.next(panels));
  }

  getImageB64(p: IPanel) {
    return `data:image/png;base64,${p.iamgeBase64}`;
  }

  setIndex(n: number) {
    this.index += n;
  }

  next = () => this.setIndex(1);
  prev = () => this.setIndex(-1);
}
